import { render, staticRenderFns } from "./Box4.vue?vue&type=template&id=27ce980e"
import script from "./Box4.vue?vue&type=script&lang=js"
export * from "./Box4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports